import React, { Fragment, ReactElement } from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import styled from 'styled-components'
import colors from '../../lib/colors'

const Styles = styled.div`
  cursor: pointer;
  font-size: 1.15rem;
  display: flex;
  min-width: min-content;
`
const LinkStyles = `
  height: 34px;
  width: 100%;
  color: ${colors.black};
  display: inline-flex;
  align-items: center;
  text-decoration: none;
  white-space: nowrap;
  svg {
    padding: 0 12px 0 14px;
    width: 22px;
    height: 22px;
  }
`
const StyledNavLink = styled(NavLink)`
  ${LinkStyles};
  &.link-active {
    color: ${(props): string => props.theme.primaryColor};
  }
  &.link-active {
    background-color: ${(props): string => props.theme.highlightColor};
  }
  :hover {
    background-color: ${(props): string => props.theme.highlightColor};
  }
`
const StyledHyperlink = styled.a`
  ${LinkStyles};
  &.link-active {
    color: ${(props): string => props.theme.primaryColor};
  }
  &.link-active {
    background-color: ${(props): string => props.theme.highlightColor};
  }
  :hover {
    background-color: ${(props): string => props.theme.highlightColor};
  }
`

export interface IMenuLinkProps {
  to: string
  icon: ReactElement
  label: string
  notExact?: boolean
  externalLink?: boolean
  hasPermission: boolean
  primaryColor: string
  highlightColor: string
}

function MenuLink(props: IMenuLinkProps): ReactElement | null {
  const {
    to,
    icon,
    label,
    notExact,
    externalLink,
    hasPermission,
    primaryColor,
    highlightColor,
  } = props

  const location = useLocation()

  const navLink = (
    <StyledNavLink
      theme={{ primaryColor, highlightColor }}
      to={to}
      activeClassName="link-active"
      exact={!notExact}
      onClick={(): void => {
        if (to === location.pathname) window.location.reload()
      }}
    >
      <Fragment>
        {icon}
        {label}
      </Fragment>
    </StyledNavLink>
  )
  const hyperLink = (
    <StyledHyperlink
      theme={{ primaryColor, highlightColor }}
      href={to}
      target="_blank"
    >
      <Fragment>
        {icon}
        {label}
      </Fragment>
    </StyledHyperlink>
  )

  return hasPermission ? (
    <Styles>{externalLink ? hyperLink : navLink}</Styles>
  ) : null
}
export default MenuLink
